import React from 'react';
import moment from 'moment';

interface EmptyCellProps {
  date: string;
  group: any;
  tasks: any;
  boxWidth: number;
  boxheight: number;
  isPastDate: boolean;
  orgWorkingDays: number[];
  onDateClick: (e: React.MouseEvent, clickedDate: string, group: any, tasksData: any, con: boolean) => void;
}

const EmptyCell: React.FC<EmptyCellProps> = ({
  date,
  group,
  tasks,
  boxWidth,
  boxheight,
  isPastDate,
  orgWorkingDays,
  onDateClick
}) => {
  const day0to6 = date ? moment(date, 'DD MMM YYYY').day() : undefined;
  const isOrgWorkingConfigured = Array.isArray(orgWorkingDays) && orgWorkingDays.length > 0;
  const d = day0to6 === 0 ? 7 : day0to6; // Map Sunday(0) -> 7 to match orgWorkingDays convention
  const isNonWorkingDay = date
    ? (isOrgWorkingConfigured
        ? !orgWorkingDays.includes(d as number)
        : [0, 6].includes(day0to6 as number))
    : false;
  const isDisabled = isPastDate || isNonWorkingDay;

  return (
    <div
      className="w-full h-full"
      // NOTE: Assign task functionality temporarily removed
      // To re-enable, uncomment the below and add back onClick handler:
      // className={`w-full h-full ${isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'} group`}
      // onClick={e => {
      //   if (!isDisabled) {
      //     onDateClick(e, date, group, tasks[group.id], isDisabled);
      //   }
      // }}
    >
      {/* 
      NOTE: Assign task hover UI temporarily removed for easier re-implementation later
      To re-enable, uncomment the below:
      
      <div className={`hidden group-hover:block ${isDisabled ? "cursor-not-allowed opacity-50" : ""}`}>
        <div
          className="w-full h-full pl-4 pb-1 pt-1 text-xs bg-[#014737]/50 rounded-lg border-2 border-dotted border-zinc-200 flex justify-center items-center text-white font-semibold font-['Inter']"
          style={{
            width: `${boxWidth}px`,
            height: `${boxheight}px`,
            minHeight: `${boxheight}px`
          }}
        >
          Assign task
        </div>
      </div>
      */}
    </div>
  );
};

export default EmptyCell; 